module.exports = __webpack_public_path__ + "static/media/university.5c7d9a42.png";